import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";
import {
  calculateMacros,
  parseUnitToShow,
  transformMealFoods,
} from "../../../../utils/nutrition-util";

const MasterMealsLibraryTable = ({ data }) => {
  const [expandedRows, setExpandedRows] = useState([]);
  const itemDetails = {
    itemProteins: undefined,
    itemCarbs: undefined,
    itemFats: undefined,
    itemCalories: undefined,
    foodKey: "foodDetails",
  };

  const parsedMeals = useMemo(() => {
    return data.map((item) => {
      const { foods = [] } = item;
      const parsedFoods = transformMealFoods(foods) || [];
      const macros = calculateMacros({
        isMeal: true,
        isRecipe: false,
        foods,
        itemDetails,
      });
      return {
        ...item,
        parsedFoods,
        macros,
      };
    });
  }, [data]);

  /**
   * Function to close and open the dropdwon
   * @param {*} index
   */
  const toggleRow = (index) => {
    setExpandedRows((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  /**
   * Open edit modal
   */
  const handleOpenModal = (_id) => {
    const body = { "modal[type]": "build-meal", mealId: _id };

    submit(`/actions/refresh/?`, {
      method: "GET",
      body,
    });
  };

  /**
   * Delete meal
   * @param {*} e
   * @param {*} _id
   */
  const deleteMeal = (e, _id) => {
    e.preventDefault();

    submit(`/actions/meal-planner/delete-master-food-library/${_id}/meal`, {
      method: "GET",
    });
  };

  return (
    <section className="meal-table" data-scrollable="true" role="table-wrapper">
      <table>
        <thead>
          <tr className="meals">
            <th className="big identifier">Food Name</th>
            <th className="medium">Brand Name</th>
            <th className="medium">Quantity</th>
            <th className="small">Proteins</th>
            <th className="small">Carbs</th>
            <th className="small">Fats</th>
            <th className="medium">kCal</th>
            <th className="medium">Actions</th>
          </tr>
        </thead>
        <tbody>
          {parsedMeals.map((item, index) => {
            const { name = "", parsedFoods = [], _id, macros } = item;
            const { proteins, carbs, fats, calories } = macros;
            return (
              <React.Fragment key={index}>
                <tr onClick={() => toggleRow(index)} className="expandable-row">
                  <td colSpan="9">
                    <div className="row-main">
                      <div className="row-summary">
                        <div className="identifier">
                          <SvgIcon
                            src={`/img/svg/angle-${
                              expandedRows.includes(index) ? "up" : "down"
                            }.svg`}
                            alt="Open"
                          />
                          <span>{name}</span>
                        </div>
                        <span></span>
                        <span>1 Serving</span>
                        <span>{proteins}</span>
                        <span>{carbs}</span>
                        <span>{fats}</span>
                        <span>{calories}</span>
                        <div className="actions">
                          <button
                            data-button-type="outline"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleOpenModal(_id);
                            }}
                          >
                            <span>Edit</span>
                          </button>
                          <button
                            data-button-type="secondary"
                            data-icon-only
                            onClick={(e) => deleteMeal(e, _id)}
                          >
                            <img
                              src="/img/new-icons/red-trash.svg"
                              alt="Delete"
                            />
                          </button>
                        </div>
                      </div>

                      {expandedRows.includes(index) && (
                        <div className="row-details">
                          {parsedFoods.map(
                            (
                              {
                                brand = "",
                                name: foodName = "",
                                calories: foodCalories = 0,
                                carbs: foodCarbs = 0,
                                fats: foodFats = 0,
                                proteins: foodProteins = 0,
                                quantityDescription = "serving",
                                _id: foodId,
                                type: foodType,
                                customQuantityNumber = 1,
                                customUnitOfMeasure = "g",
                              },
                              i
                            ) => {
                              return (
                                <div
                                  key={`${_id}-${foodId}-${i}`}
                                  className="detail-row"
                                >
                                  <span>{foodName}</span>
                                  <span>{brand}</span>
                                  <span>
                                    {customQuantityNumber}{" "}
                                    {parseUnitToShow(
                                      customQuantityNumber,
                                      foodType,
                                      customUnitOfMeasure,
                                      quantityDescription
                                    )}
                                  </span>
                                  <span>{foodProteins}</span>
                                  <span>{foodCarbs}</span>
                                  <span>{foodFats}</span>
                                  <span>{foodCalories}</span>
                                  <span></span>
                                </div>
                              );
                            }
                          )}
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </section>
  );
};

MasterMealsLibraryTable.propTypes = {
  data: PropTypes.array,
};

export default MasterMealsLibraryTable;
